import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { waLink } from "../../brand";

export default function FinalCTA() {
  return (
    <section id="cta" data-testid="final-cta-section" className="relative py-20 sm:py-28">
      <div className="container-x">
        <div className="reveal grad-border p-10 sm:p-16 text-center relative overflow-hidden">
          <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-gradient-to-br from-[#ff3b1f]/25 via-[#ff8a00]/20 to-transparent rounded-full blur-3xl" />
          <div className="relative">
            <div className="eyebrow justify-center inline-flex mb-5">Es hora de ejecutar</div>
            <h2 className="font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.05]">
              Deja de perder leads. <br className="hidden sm:block" />
              <span className="text-gradient">Empieza a vender en automático.</span>
            </h2>
            <p className="mt-6 text-zinc-400 max-w-2xl mx-auto text-lg">
              Una conversación de 30 minutos puede cambiar la economía de tu negocio. Cero compromiso, mucha claridad.
            </p>
            <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <Link to="/contacto" className="btn-primary" data-testid="final-cta-primary">
                Agenda mi consultoría <ArrowRight className="w-4 h-4" />
              </Link>
              <a href={waLink()} target="_blank" rel="noreferrer" className="btn-secondary" data-testid="final-cta-whatsapp">
                <span className="w-2 h-2 rounded-full bg-[#25D366] pulse-dot" />
                Hablar por WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
